import APIService from './APIService';

export default {
  index() {
    return new Promise((resolve, reject) => {
      APIService.apiCall()
        .get('/expurgos-bdgd/index')
        .then((response) => resolve(response.data.data))
        .catch((error) => reject(error));
    });
  },
  save(postData) {
    return APIService.apiCall().post('/expurgos-bdgd/save', JSON.stringify(postData));
  },
  getDatesAndRegistersImportedEntities() {
    return APIService.apiCall().get('/expurgos-bdgd/getDatesAndRegistersImportedEntities');
  },
  getImportedEntitiesAndRegistersByDate(date, companyId, bdgdVersionId) {
    return APIService.apiCall().get(`/expurgos-bdgd/getImportedEntitiesAndRegistersByDate/${date}/${companyId}/${bdgdVersionId}`);
  }
};
